import { noPrepOpt } from "../PrepMenuOptions";
import { Alert } from "@mui/material";
import { useFixer } from "./Fixer";
import { jsx as _jsx } from "react/jsx-runtime";
export function PrepNoOptions(props) { const fix = useFixer({ value: props.value, autoFix: () => noPrepOpt, onChange: props.onChange }); if (fix) {
    return /*#__PURE__*/ _jsx(Alert, { severity: "warning", style: { marginTop: 8, marginBottom: 8 }, children: "Some background properties need to update. Please save product when you're done." });
} return null; }
